import isLodashEmpty from 'lodash/isEmpty'

export const isEmpty = (value: any) => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return false
  }

  return isLodashEmpty(value)
}
